(function() { window.GUID_322de318_3ae7_4db6_a843_1bbec03e83a6 = { getGuid: function() { return "322de318-3ae7-4db6-a843-1bbec03e83a6"; } }; })();
var CS;
(function (CS) {
    var Ads;
    (function (Ads) {
        var countUntilNextAdd = 0;
        var showAdEveryX = 10;
        // Ne peux pas être nommé ShowFullscreenAd pour ne pas etre en conflit avec la méthode native
        function ShowFullscreen(pageValue = 1) {
            if (CS.CommonData.Current.IsPremium ||
                CS.CommonData.Current.IsPremiumEssential) {
                return;
            }
            //Limité a 1 ad aux 2 heures dans admob
            CS.NativeApp.NA_ShowFullscreenAd("false");
            //Disabled until it works better
            //countUntilNextAdd += pageValue;
            //if (countUntilNextAdd >= showAdEveryX) {
            //    countUntilNextAdd -= showAdEveryX;
            //    console.log("ShowFullScreenAd");
            //    //Disable native until we fix the close button under the status bar on ios
            //    //if (typeof (ShowFullscreenAd) == "function") {
            //    //    ShowFullscreenAd();
            //    //}
            //    //else {
            //        CS.Controls.Popup.ShowAjaxModal(Url.CSUrl("fullscreenad"), null, function(popup) {
            //            GoogleAds.BindAds(true);
            //        }, null);
            //    //}
            //}
        }
        Ads.ShowFullscreen = ShowFullscreen;
        function PreLoadAd() {
            if (!CS.CommonData.Current.IsPremium &&
                !CS.CommonData.Current.IsPremiumEssential) {
                CS.NativeApp.NA_LoadFullscreenAd(null);
            }
        }
        Ads.PreLoadAd = PreLoadAd;
        function RefreshGoogleAds($container) {
            if (!CS.GlobalConst.UseGoogleAdsense || !CS.CommonData.Current.AdsEnabled) {
                return;
            }
            if (typeof GoogleAds === "object" && typeof GoogleAds.BindAds === "function") {
                GoogleAds.BindAds(true, $container);
            }
        }
        Ads.RefreshGoogleAds = RefreshGoogleAds;
        function RefreshDynamicGoogleAds($container) {
            if (!CS.GlobalConst.UseGoogleAdsense || !CS.CommonData.Current.AdsEnabled) {
                return;
            }
            if (typeof GoogleAds === "object" && typeof GoogleAds.BindAds === "function") {
                GoogleAds.BindAds(true, $container);
            }
        }
        Ads.RefreshDynamicGoogleAds = RefreshDynamicGoogleAds;
        function TryPremiumOrSubscribe(feature = CS.Enumeration.PremiumFeature.Generic, backOnCancel = false) {
            console.log("TryPremiumOrSubscribe " + feature);
            let canGoBack = true;
            const url = CS.Url.CSUrl("AskAdsForPremium");
            const data = {
                featureId: feature,
            };
            if (url != null && typeof url === "string") {
                //popup avec choix de essayer avec pub ou s'abbonner.  Devrait avoir un exemple et explication du feature
                CS.Controls.Popup.ShowAjaxModal(url, data, ({ popup }) => {
                    // OnLoad
                    $("#button-watch-ad").on("click", (e) => {
                        //pour debug
                        //canGoBack = false;
                        //CS.Ajax.Post('/general/unlockpremium', data, function () {
                        //    popup.Close();
                        //    CS.Nav.Refresh();
                        //});
                        $("body").offon("RewardAdFailedToLoad.trypremium", function () {
                            alert("Ad failed to load, you can try again");
                        });
                        $("body").offon("RewardAdSuccessful.trypremium", function () {
                            canGoBack = false;
                            CS.Ajax.Post("/general/unlockpremium", data, function () {
                                popup.Close();
                                CS.Nav.Refresh();
                            });
                        });
                        CS.NativeApp.NA_ShowRewardAd("true");
                    });
                    console.log("preload ad");
                    CS.NativeApp.NA_LoadRewardAd("");
                }, ({ popup }) => {
                    // OnClose
                    $("body").off("RewardAdFailedToLoad.trypremium");
                    $("body").off("RewardAdSuccessful.trypremium");
                    console.log("popup closed " + canGoBack + " " + backOnCancel);
                    if (canGoBack && backOnCancel) {
                        CS.Nav.GoBack();
                    }
                }, true);
            }
        }
        Ads.TryPremiumOrSubscribe = TryPremiumOrSubscribe;
    })(Ads = CS.Ads || (CS.Ads = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-ads.js.map
